import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CardToBidComponent } from './card-to-bid.component';
import { SharedModule } from '../../shared/shared.module';
import { IconModule } from 'src/app/directives/icon.module';
import { StopwatchShared } from '../../shared/stopwatch/stopwatch.module';
import { LiveBidActionComponent } from './live-bid-action/live-bid-action.component';
import { PreBidActionComponent } from './pre-bid-action/pre-bid-action.component';
import { PurchaseActionComponent } from './purchase-action/purchase-action.component';
import { OnlineBidActionComponent } from './online-bid-action/online-bid-action.component';
import { SuperBidButtonModule } from '../super-bid-button/super-bid-button.module';

@NgModule({
  imports: [CommonModule, SharedModule, IconModule, StopwatchShared, SuperBidButtonModule],
  declarations: [
    CardToBidComponent,
    LiveBidActionComponent,
    PreBidActionComponent,
    PurchaseActionComponent,
    OnlineBidActionComponent,
  ],
  exports: [
    CardToBidComponent,
    LiveBidActionComponent,
    PreBidActionComponent,
    PurchaseActionComponent,
    OnlineBidActionComponent,
  ],
})
export class CardToBidShared {}
